import { render } from "./TwoFactorVerification.vue?vue&type=template&id=129a4468&scoped=true"
import script from "./TwoFactorVerification.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerification.vue?vue&type=script&lang=js"

import "./TwoFactorVerification.vue?vue&type=style&index=0&id=129a4468&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129a4468"]])

export default __exports__